import * as angular from "angular";
import {IController} from "angular";
import {SchedulingProjectDialogService} from "../../services/scheduling-project-dialog.service";
import {VisitPlanHttpService} from "../../angular/services/visit-plan-http.service";
import {CommonsFacadeService} from "../../../commons/angular/state/commons/commons-facade.service";
import {VisitPlanTemplateService} from "../../services/visit-plan-template.service";

export class SchedulingProjectVisitPlanTemplatesViewComponent implements IController {

  public infiniteScroll: any;
  private templatesRef: any;
  private loadLimit: number = 30;

  /* @ngInject */
  constructor(
    private schedulingProjectDialogService: SchedulingProjectDialogService,
    private visitPlanHttpService: VisitPlanHttpService,
    private splitService: any,
    private bringozToastService: any,
    private $infiniteScroll: any,
    private $q: any,
    private commonsFacadeService: CommonsFacadeService,
    private confirmDialogService: any,
    private visitPlanTemplateService: VisitPlanTemplateService
  ) {
  }

  $onInit() {
    this.templatesRef = {
      _cursor: undefined,

      $next: (config) => {
        const deferred = this.$q.defer();

        if (this.templatesRef._cursor === 'DONE') {
          deferred.resolve([]);
          return deferred.promise;
        }

        this.commonsFacadeService.setLoaderOn();

        this.visitPlanHttpService.getAllTemplates(1000).subscribe({
          next: (response) => {
            this.templatesRef._cursor = 'DONE';
            deferred.resolve(response.list || []);
            this.commonsFacadeService.setLoaderOff();
          },
          error: (err) => {
            console.error(err);
            this.bringozToastService.error('Failed to load templates');
            deferred.reject(err);
            this.commonsFacadeService.setLoaderOff();
          }
        });

        return deferred.promise;
      }
    };

    this.infiniteScroll = this.$infiniteScroll(this.templatesRef, this.loadLimit, { getFullData: true });
  }

  onCreateTemplate(event) {
    this.schedulingProjectDialogService.createVisitPlanTemplate(event).then((result) => {
       if(result) {
         this.createTemplate(result);
       }
    });
  }

  createTemplate(payload) {
    this.visitPlanTemplateService.createTemplate(payload)
      .subscribe({
        next: () => {
          this._reload();
        }
      });
  }

  onEditTemplate(template, event) {
    this.schedulingProjectDialogService.createVisitPlanTemplate(event, template).then((result) => {
       if(result) {
         this.updateTemplate(result);
       }
    });
  }

  updateTemplate(payload) {
    const templateId = payload.id;

    // Remove id from payload to avoid sending it in the body
    // const updatePayload = {
    //   name: payload.name,
    //   visitScheduleOptimizationSettings: payload.visitScheduleOptimizationSettings,
    //   visitSlotProviderTypeRegistry: payload.visitSlotProviderTypeRegistry
    // };

    this.visitPlanTemplateService.updateTemplate(templateId, payload)
      .subscribe({
        next: () => {
          // Reload the list to show updated data
          this._reload();
        }
      });
  }

  onDeleteTemplate(template, event) {
    const title = 'Delete Template';
    const text = `Are you sure you want to delete "${template.name}"? This action cannot be undone.`;

    this.confirmDialogService.confirm(title, text, event)
      .then(() => {
        this.visitPlanTemplateService.deleteTemplate(template.id)
          .subscribe({
            next: () => {
              this.infiniteScroll.removeItems([template], 'id');
            }
          });
      })
      .catch(() => {
        // User cancelled the dialog
      });
  }

  private _reload() {
    this.templatesRef._cursor = undefined;
    this.infiniteScroll.reload();
  }

}

angular
  .module('bringoz.admin.scheduling-project')
  .component('schedulingProjectVisitPlanTemplatesView', {
    template: require('./scheduling-project-visit-plan-templates-view.html').default,
    controller: SchedulingProjectVisitPlanTemplatesViewComponent
  });
